import { Link } from 'react-router-dom';
import { HandySvg } from 'handy-svg';
import iconCross from '../../assets/icons/svg-sprite/close-cross.svg';
import bonusBanner from '../../assets/images/banners/bonusBanner.png';

const BonusBanner = () => {

    return (
        <>
            <section className="link-banner link-banner--non-abonent page__link-banner js-closing-banner">
                <h6 className="visuallyhidden">Рекламный баннер</h6>
                <div className="link-banner__inner page-container" style={{backgroundColor: '#a6b1b6'}}>
                    <div className="link-banner__pic-wrap">
                        <img className="link-banner__img" alt="Подарки всем!" width="auto" height="auto" src={bonusBanner}/>
                    </div>
                    <div className="link-banner__info-container">
                        <span className="link-banner__title">Подарки всем!</span>
                        <div className="link-banner__description">
                            <p>Скидки и выгодные предложения <br/>абонентам «Телекарты»</p>
                        </div>
                    </div>
                    <Link className="link-banner__link" to="//telekarta.tv/bonus/"></Link>
                    <button className="link-banner__close-btn banner-close-btn js-close-btn" type="button">
                        <HandySvg className="svg-icon" src={iconCross} width="12" height="12"/>
                    </button>
                </div>
            </section>
        </>
    );
};

export default BonusBanner;